import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthenticationServiceImpl } from '../authentication/authentication-service-impl.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly cypressTokenKey = 'cypress_token';

  constructor(
    private readonly authenticationService: AuthenticationServiceImpl,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const token = sessionStorage.getItem(this.cypressTokenKey);

    if (token) {
      this.authenticationService.receiveToken(token);
      //removing the cypress test session token after logged in
      sessionStorage.removeItem(this.cypressTokenKey);
    }
    if (
      !this.authenticationService.loggedIn &&
      this.authenticationService.vspAcessCookieExists() &&
      localStorage &&
      (localStorage.getItem('login_redirect') == null ||
        localStorage.getItem('login_redirect') === '')
    ) {
      localStorage.setItem('login_redirect', state.url);
    }
    // check if we're already logged in, if so move on
    if (
      this.authenticationService.isLoggedIn() &&
      this.authenticationService.isAuthenticated() &&
      this.authenticationService.vspAcessCookieExists()
    ) {
      return of(true);
    } else {
      // check if page load or router navigation, then login if appropriate
      return this.authenticationService
        .checkAuthentication(environment.oauthRedirectUrl)
        .pipe(
          tap(result => {
            if (result) {
              let redirectUrl = '';
              if (
                localStorage &&
                localStorage.getItem('login_redirect') !== null &&
                localStorage.getItem('login_redirect') !== ''
              ) {
                // @ts-ignore
                redirectUrl = localStorage.getItem('login_redirect');
                localStorage.removeItem('login_redirect');
                this.router.navigateByUrl(redirectUrl);
              }
            }
            return result;
          })
        );
    }
  }
}
